<script setup lang="ts">
// 2026-10-06 (Japan mini charts spec §3.1): Japan top strip in the BGA-vs-NAS format (JAPAN · NIY · TOPIX · FX),
// replacing JapanNiyStrip. The NIY anchor comes from ctx (Dashboard's 60 s japanSignal poll); the SELL/BUY band moved
// to the Japan vs NIY chart.
import JapanSparklineBar from '../japan/JapanSparklineBar.vue'
import type { SignalTabCtx } from '../nav/fundPages'
defineProps<{ ctx: SignalTabCtx }>()
</script>
<template>
  <JapanSparklineBar :anchor-price="ctx.japanAnchorPrice" />
</template>
